export const summaryBannerContainerSx = (theme) => ({
  backgroundColor: theme.palette.background.secondary,
  borderRadius: '5px',
  padding: '8px',
  margin: '8px auto 24px auto',
  display: 'flex',
  maxWidth: '345px',
});

export const moodContainerSx = { margin: '0px 12px' };

export const moodLabelSx = {
  color: '#71767b',
  fontSize: '8px',
  fontWeight: 500,
};

export const summaryContainerSx = {
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  marginLeft: '12px',
};

export const totalDistanceTextSx = (theme) => ({
  color: theme.palette.quaternary.main,
  fontSize: '20px',
  fontWeight: 500,
  textShadow: 'grey 0px 0px 0.5px',
  lineHeight: 1,
});
